module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Newsletter":{"heading":"TIPY A INSPIRACE DO MAILU","text":"Přihlaste se k doběru našeho newsleteru a žádná sleva Vám už neuteče. Jednou měsíčně, přímo do Vaší schránky."}}}')
  delete Component.options._Ctor
}
